import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class DepartmentService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) { }

	// Application CRUD operations
	getDepartments(companyId: number): Observable<any> {
		return this.http.get(`${this.uri}/departments/${companyId}`);
	}
}
